import { formatMoneyCompact } from "../../lib/format/money";
import { monthLabelChart } from "../../lib/overview-period";

export interface MonthlySeriesPoint {
  month: string;
  income: string;
  paid: string;
}

interface IncomeExpenditureChartProps {
  months: MonthlySeriesPoint[];
}

export function IncomeExpenditureChart({ months }: IncomeExpenditureChartProps) {
  const maxValue = Math.max(
    ...months.flatMap((point) => [
      Number.parseFloat(point.income),
      Number.parseFloat(point.paid),
    ]),
    10_000,
  );
  const chartMax = maxValue * 1.12;

  return (
    <div>
      <div className="mb-5 flex items-center gap-[15px] text-xs text-[#78828e]">
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-[3px] bg-edlab-green" />
          Income
        </span>
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-[3px] bg-[#b9d6ca]" />
          Paid
        </span>
      </div>
      <svg
        className="h-[200px] w-full"
        role="img"
        aria-label="Monthly income and paid expenditure"
        viewBox="0 0 620 200"
        preserveAspectRatio="xMidYMid meet"
      >
        {[0, 1, 2, 3].map((index) => {
          const y = 25 + index * 45;
          const label = formatMoneyCompact((chartMax * (1 - index / 3)).toFixed(0));
          return (
            <g key={index}>
              <line x1="60" x2="595" y1={y} y2={y} stroke="#e8ebef" />
              <text x="50" y={y + 4} textAnchor="end" fill="#727c88" fontSize="11">
                {label}
              </text>
            </g>
          );
        })}
        {months.map((point, index) => {
          const x = 120 + index * (420 / Math.max(1, months.length - 1));
          const income = Number.parseFloat(point.income);
          const paid = Number.parseFloat(point.paid);
          const incomeHeight = (income / chartMax) * 135;
          const paidHeight = (paid / chartMax) * 135;

          return (
            <g key={point.month}>
              <rect
                x={x - 27}
                y={160 - incomeHeight}
                width="25"
                height={incomeHeight}
                rx="4"
                fill="#20836a"
              >
                <title>{`${monthLabelChart(point.month)} Income: ${formatMoneyCompact(point.income)}`}</title>
              </rect>
              <rect
                x={x + 5}
                y={160 - paidHeight}
                width="25"
                height={paidHeight}
                rx="4"
                fill="#b9d6ca"
              >
                <title>{`${monthLabelChart(point.month)} Paid: ${formatMoneyCompact(point.paid)}`}</title>
              </rect>
              <text x={x + 3} y="185" textAnchor="middle" fill="#727c88" fontSize="12">
                {monthLabelChart(point.month)}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
